<template>
  <div>
    <loading
      loader="dots"
      :height="170"
      :width="170"
      color="#3282b8"
      background-color="#505273"
      transition="fade"
      :active="isLoading"
      :is-full-page="true"
    ></loading>
    <div v-if="jkkp === 6">
      <h4 class="info-text">BAHAGIAN C - Huraian kemalangan atau kejadian berbahaya</h4>
      <div class="row justify-content-center">
        <div class="col-sm-10">
          <textarea class="address"
            v-model="inDetail"
            placeholder="Sila huraikan apa yang berlaku sebelum, semasa dan selepas kejadian."
          ></textarea>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col text-center">
          <base-button @click="submit()">Finish</base-button>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-lg-6">
          <h4 class="info-text">BAHAGIAN C - Keracunan Pekerjaan / Penyakit</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <base-input label="Diagnosis / Diagnosis Sementara" v-model="doc.diagnosis" ></base-input>
              <base-input label="Tarikh Diagnosis">
                <el-date-picker v-model="doc.diagnosis_date" type="date"></el-date-picker>
              </base-input>
              <base-input label="Nama Doktor" v-model="doc.name"></base-input>
              <base-input label="Alamat Doktor" >
                <textarea class="address" v-model="doc.addr"></textarea>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-lg-6" style="border-left: solid red">
          <h4 class="info-text">BAHAGIAN D</h4>
          <div class="row justify-content-center">
            <div class="col-sm-10">
              <textarea
                v-model="inDetail"
                class="huraian"
                placeholder="Huraian pekerjaan yang membawa kepada keracunan pekerjaan / penyakit pekerjaan (Sila huraikan sebarang kerja
  yang dibuat oleh orang yang terlibat yang mungkin telah membawa kepada penyakit. Jika mungkin disebabkan oleh pendedahan kepada sebarang agen semasa kerja, contoh kimia yang spesifik - sila nyatakan agen berkenaan). "
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
          <base-button @click="submit()" :disabled="dis">Finish</base-button>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
      </div> 
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { Circle8 } from "vue-loading-spinner";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Loading,
    Circle8
  },
  data() {
    return {
      isLoading: false,
      dis: false,
      load: false,
      secB: [],
      image: null,
      inDetail: "",
      value1: "",
      tableSiteRoute: [
        {
          siteRoute: "Route A"
        },
        {
          siteRoute: "Route B"
        }
      ],
      selects: {
        condition: [
          { value: "operational", label: "Operational" },
          { value: "Not operational", label: "Not Operational" }
        ]
      },
      model: {
        file: null
      },
      idrecord: "",
      notifier: {
        name: "",
        designation: "",
        org: "",
        phoneno: "",
        add: "",
        roc: "",
        jkkpregno: "",
        other: ""
      },
      victim: {
        name: "",
        dob: "",
        kp: "",
        org: "",
        nopekerja: "",
        nationality: "",
        gender: "",
        occupation: "",
        inlocation: "",
        orgaddr: "",
        intimestamp: "",
        reportdate: ""
      },
      doc:{
        diagnosis: "",
        diagnosis_date: "",
        name: "",
        addr: "",
      },
      jkkp: "",
      inTime: "",
      inLocation: "",
      medic:{
        name: "",
        designation: "",
        telNo: "",
        addr: ""
      },
      data: []
      // indetails: "",
    };
  },
  mounted() {
      this.getSecBDetails();
  },
  methods: {
    // getJKKP(){
    //     this.$root.$on("jkkp", data => {
    //         console.log(data)
    //         this.jkkp = data
    //     })
    // },
    // getImage(){
    //     this.$root.$on("image", data => {
    //         console.log(data)
    //         this.image = data
    //     })
    // },
    getSecBDetails(){
        this.$root.$on("secB", (data) => {
        console.log(data);
        this.data = data
        this.jkkp = this.data.jkkp
        console.log(this.jkkp)
      });
    },
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    },
    submit() {
      if(this.jkkp == 6) {
          if(this.inDetail == ""){
              swal({
                title: "Data Error!",
                text: "All data must be filled in.",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
            });
          } else {
            this.load = true;
            this.isLoading = true;

            let obj = {
              jkkp: this.jkkp,
              incidenttype: parseInt(this.data.incidenttype),
              investigationid: 0,
              accidentclass: 1,
              accidenttype: 1,
              accidentcause: 1,
              notifiername: this.data.notifiername,
              notifierdesignation: this.data.notifierdesignation,
              notifiercompany: this.data.notifiercompany,
              notifiercompanyaddr: this.data.notifiercompanyaddr,
              notifiertelno: this.data.notifiertelno,
              rocno: this.data.rocno,
              jkkpregno: this.data.jkkpregno,
              othercontact: this.data.othercontact,
              industrycode: this.data.industrycode,
              industrysector: this.data.industrysector,
              medicname: "",
              medicdesignation: "",
              mediccompany: "",
              mediccompanyaddr: "",
              medictelno: "",
              diagnosis: "",
              diagnosisdate: "",
              doctorname: "",
              doctoraddr: "",
              victimname: this.data.victimname,
              victimbirth: this.data.victimbirth,
              victimkp: this.data.victimkp,
              victimnation: this.data.victimnation,
              victimsex: this.data.victimsex,
              victimoccup: this.data.victimoccup,
              victimcompany: this.data.victimcompany,
              victimcompanyaddr: this.data.victimcompanyaddr,
              victimstaffid: this.data.victimstaffid,
              victimage: "",
              victimtelno: "",
              victimworkarea: this.data.victimworkarea,
              victimworkscope: "",
              victimsv: "",
              victimstarwork: "",
              victimhomeaddr: "",
              vehregno: "",
              vehtype: "",
              roadtax: "",
              puspakom: "",
              incidentloc: this.data.incidentloc,
              incidentlocdetail: "",
              incidenttime: this.data.incidenttime,
              reportdatetoJKKP: this.data.reportdatetoJKKP,
              incidentimg: this.data.incidentimg,
              incidentlat: this.data.incidentlat,
              incidentlong: this.data.incidentlong,
              incidentdetail: "",
              noofmc: "",
              nooflti: "",
              incidentdetail: this.inDetail,
              classcode: this.data.classcode
            };

            this.$http.post(":9994/api/v1/mobile/incident", obj).then((res) => {
              if (!res.error) {
                let response = res.message;
                swal({
                  title: "Successfull!",
                  text: res.message,
                  type: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                }).then((result) => {
                  this.$router.go();
                });
                this.isLoading = false;
                this.load = false;
              } else {
                swal({
                  title: "Something went wrong!",
                  text: res.message,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
                this.isLoading = false;
                this.load = false;
              }
            });
          }
        
      } else{
          if(this.doc.addr == "" || this.doc.diagnosis == "" ||
          this.doc.diagnosis_date == "" || this.doc.name == "" || this. inDetail == ""){
              swal({
                    title: "JKKP 7",
                    text: "All data must be filled in.",
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    buttonsStyling: false,
                });
          } else {
            this.load = true;
            this.isLoading = true;

            let obj = {
              jkkp: this.jkkp,
              incidenttype: this.data.incidenttype,
              investigationid: 0,
              accidentclass: 1,
              accidenttype: 1,
              accidentcause: 1,
              notifiername: this.data.notifiername,
              notifierdesignation: this.data.notifierdesignation,
              notifiercompany: this.data.notifiercompany,
              notifiercompanyaddr: this.data.notifiercompanyaddr,
              notifiertelno: this.data.notifiertelno,
              rocno: this.data.rocno,
              jkkpregno: this.data.jkkpregno,
              othercontact: this.data.othercontact,
              industrycode: this.data.industrycode,
              industrysector: this.data.industrysector,
              medicname: this.data.medicname,
              medicdesignation: this.data.medicdesignation,
              mediccompany: this.data.mediccompany,
              mediccompanyaddr: this.data.mediccompanyaddr,
              medictelno: this.data.medictelno,
              diagnosis: "",
              diagnosisdate: "",
              doctorname: "",
              doctoraddr: "",
              victimname: this.data.victimname,
              victimbirth: this.data.victimbirth,
              victimkp: this.data.victimkp,
              victimnation: this.data.victimnation,
              victimsex: this.data.victimsex,
              victimoccup: this.data.victimoccup,
              victimcompany: this.data.victimcompany,
              victimcompanyaddr: this.data.victimcompanyaddr,
              victimstaffid: this.data.victimstaffid,
              victimage: "",
              victimtelno: "",
              victimworkarea: this.data.victimworkarea,
              victimworkscope: "",
              victimsv: "",
              victimstarwork: "",
              victimhomeaddr: "",
              vehregno: "",
              vehtype: "",
              roadtax: "",
              puspakom: "",
              incidentloc: this.data.incidentloc,
              incidentlocdetail: "",
              incidenttime:this.data.incidenttime,
              reportdatetoJKKP: this.data.reportdatetoJKKP,
              incidentimg: this.data.incidentimg,
              incidentlat: this.data.incidentlat,
              incidentlong: this.data.incidentlong,
              incidentdetail: "",
              noofmc: "",
              nooflti: "",
              diagnosis: this.doc.diagnosis, 
              diagnosisdate: moment(this.doc.diagnosis_date).format("YYYY-MM-DD"),
              doctorname: this.doc.name,
              doctoraddr: this.doc.addr,
              incidentdetail: this.inDetail
            };
             this.$http.post(":9994/api/v1/mobile/incident", obj).then((res) => {
              if (!res.error) {
                let response = res.message;
                swal({
                  title: "Successfull!",
                  text: res.message,
                  type: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                }).then((result) => {
                  this.$router.go();
                });
                this.isLoading = false;
                this.load = false;
              } else {
                swal({
                  title: "Something went wrong!",
                  text: res.message,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
                this.isLoading = false;
                this.load = false;
              }
            });
          }
      }
    }
  }
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.address {
  width: 100%;
  height: 300px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
